const cleanFileName = filename => {
  const extension = filename.split('.').reverse()[0];
  const cleaned = filename.replace(/\.[^/.]+$/, '').replace(/\W/g, '-');
  return `${cleaned}.${extension}`;
};

export default cleanFileName;
